import React from 'react';
import {useTranslation} from "react-i18next";
import {ReactComponent as EyeIco} from "../../../../../images/icons/eye.svg";
import {ConfigApi, OrderType} from "../../../../services/Api/types";
import CategoryHelper from "../../../../services/Menu/services/Category/CategoryHelper";

interface Props {
    locale?: string;
    onClick: () => void;
    orderType: OrderType;
    menus: any[];
    items: any[];
    availabilities: any[];
    config: ConfigApi | undefined;
    pickupDate: string | undefined;
}

const MenuCategoryAvailabilityInfo = ({
                                          locale,
                                          onClick,
                                          orderType,
                                          menus,
                                          items,
                                          availabilities,
                                          config,
                                          pickupDate
                                      }: Props) => {
    const {t} = useTranslation();
    const infos = CategoryHelper.getAvailabilityInfo(menus, items, availabilities, config, orderType, pickupDate, t, locale);

    const drawInfo = (info: {
        text: string;
        typesText?: string;
        dateText?: string;
        isNowAvailable?: boolean;
        includeCurrentType?: boolean;
        currentType?: boolean;
    }) => {
        let restOfText = "";

        if ((info.currentType || info.includeCurrentType) && !info.isNowAvailable && info.dateText) {
            restOfText = ` ${info.dateText}`;
        } else if (!info.currentType && !info.includeCurrentType) {
            if (info.isNowAvailable) {
                restOfText = ` ${info.typesText ?? ""}`;
            } else {
                if (info.dateText) {
                    restOfText = ` ${info.typesText ?? ""} - ${info.dateText}`;
                }
            }
        }

        return (
            <>
                <span>{info.text}</span>
                <span>{restOfText}</span>
            </>
        );
    };

    return (
        <div
            className="menu-category-availability-info d-flex flex-column align-items-center justify-content-center fw-normal"
            onClick={onClick}>
            {
                infos.filter((_, index) => index < 2).map((info, index) => (
                    <div className="d-flex flex-column text-center text-warning"
                         key={`${JSON.stringify(info)}-${index}`}>
                        {drawInfo(info)}
                    </div>
                ))
            }
            {infos.length > 2 && (
                <div className="d-flex flex-column text-center text-warning">
                    ...
                </div>
            )}
            <EyeIco className="mt-1"/>
        </div>
    )
}

export default MenuCategoryAvailabilityInfo;